import React from 'react';
import classnames from 'classnames';
import { useLocation } from '@reach/router';
import { navigate, Link } from 'gatsby';

import { RESOURCE_CENTER } from 'constants/urls';

import * as styles from './styles.module.scss';

const BackNavigate = () => {
  const location = useLocation();

  const BACK_BTN = location.hash === '' ? 'button' : 'link';
  const btnText = 'back to Blog';

  return (
    <>
      {BACK_BTN === 'button' ? (
        <button
          onClick={() => navigate(-1)}
          className={classnames(styles.breadcrumbs, 'scr-txt-up scr-blue')}
        >
          {btnText}
        </button>
      ) : (
        <Link
          to={RESOURCE_CENTER}
          className={classnames(styles.breadcrumbs, 'scr-txt-up scr-blue')}
          id="link-back-nav"
        >
          {btnText}
        </Link>
      )}
    </>
  );
};

export default BackNavigate;
